<community-svg-sprite />

<div class="community-layout">
    <div class="container">
        <side-menu [totalRooms]="totalRooms"></side-menu>
        <div class="community-layout-wrapper">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10 col-xl-10 desktop-fixed-width">

                  @if(isCommunityMembersInfoVisible()) {
                    <div class="community-info" *allowRole="['ADMIN']">
                      <div class="community-info-icon">
                        <div class="icon">
                          <svg>
                            <use xlink:href="#identityIcon"></use>
                          </svg>

                        </div>

                      </div>
                      <div class="community-info-content">
                        <p class="info">
                                <span [innerHTML]="'community.communityBanner.message' | translate: {
                                currentActiveMembers: totalActiveMembers,
                                    maxActiveMembers: maxCommunityMembers }">
                                </span>
                          <a href="javascript:void(0)" (click)="onUpgrade()">
                            {{'community.communityBanner.upgradeNow' | translate}}
                          </a>
                        </p>
                        <p class="text"> (Only you can see this message) </p>
                      </div>
                    </div>
                  }
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>
